export const S3_PATH = "https://bridgesplit-app.s3.amazonaws.com";

export const LOGO_URL = `${S3_PATH}/logo/500.png`;

export const S3_ORGANIZATIONS_PATH = `${S3_PATH}/organizations`;
export const ORCA_LOGO = `${S3_ORGANIZATIONS_PATH}/orca-logo.png`;
export const RAYDIUM_LOGO = `${S3_ORGANIZATIONS_PATH}/raydium-logo.png`;

export const METEORA_LOGO = `${S3_ORGANIZATIONS_PATH}/meteora-logo.jpeg`;
export const SANCTUM_LOGO = `${S3_ORGANIZATIONS_PATH}/sanctum-logo.jpeg`;
export const JLP_LOGO = `${S3_PATH}/tokens/JLP.png`;
export const MARGIN_FI_LOGO = `${S3_PATH}/icons/mfi.jpg`;

export const LOOPSCALE_ICON_LIGHT = `${S3_PATH}/logo/loopscale-icon-light.svg`;
export const LOOPSCALE_ICON_DARK = `${S3_PATH}/logo/loopscale-icon-dark.svg`;
